import { useState } from "react";
import { services, type ServiceCategory } from "@/config/services";
import ServiceCard from "@/components/feature/ServiceCard";
import Reveal from "@/components/feature/Reveal";

type FilterKey = "all" | ServiceCategory;

const filters: { key: FilterKey; label: string }[] = [
  { key: "all", label: "Tümü" },
  { key: "sac", label: "Saç Tasarımı" },
  { key: "gelin", label: "Gelin & Özel Gün" },
  { key: "bakim", label: "Güzellik & Bakım" },
];

export default function ServicesSection() {
  const [active, setActive] = useState<FilterKey>("all");

  const visible =
    active === "all" ? services : services.filter((s) => s.category === active);

  return (
    <section id="hizmetler" className="scroll-mt-24 bg-background-100">
      <div className="mx-auto max-w-7xl px-4 py-16 md:px-6 md:py-24">
        <Reveal>
          <p className="text-xs uppercase tracking-[0.28em] text-accent-600 md:text-sm">
            Hizmetlerimiz
          </p>
          <h2 className="mt-4 max-w-xl font-heading text-3xl leading-tight text-primary-800 md:text-5xl">
            Kendiniz için seçtiğiniz zaman.
          </h2>
        </Reveal>

        <Reveal delay={80}>
          <div
            className="mt-8 inline-flex flex-wrap gap-1 rounded-full border border-background-300/60 bg-background-50 p-1"
            role="group"
            aria-label="Hizmet filtresi"
          >
            {filters.map((f) => {
              const isActive = active === f.key;
              return (
                <button
                  key={f.key}
                  onClick={() => setActive(f.key)}
                  aria-pressed={isActive}
                  className={`whitespace-nowrap rounded-full px-5 py-2.5 text-sm font-medium transition-colors ${
                    isActive
                      ? "bg-primary-800 text-background-50"
                      : "text-foreground-600 hover:text-primary-800"
                  }`}
                >
                  {f.label}
                </button>
              );
            })}
          </div>
        </Reveal>

        <div className="mt-10 grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {visible.map((service, i) => (
            <Reveal key={service.id} delay={(i % 3) * 80}>
              <ServiceCard service={service} />
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}